<template>
	<!-- 编辑界面 -->
	<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules">
			<el-form-item label="所属门店" prop="storeKeyId">
				<el-select filterable v-model="editForm.storeKeyId" placeholder="请选择门店" clearable size="small" class="input_200px" :disabled="editForm.isConfirm == true">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="开支内容" prop="content">
				<el-input v-model="editForm.content" type="textarea" :rows="3" class="input_200px" size="small" :disabled="editForm.isConfirm == true" />
			</el-form-item>
			<el-form-item label="开支金额" prop="expenseMoney">
				<el-input-number v-model.number="editForm.expenseMoney" type="number" class="input_200px" size="small" :disabled="editForm.isConfirm == true" />
			</el-form-item>
			<el-form-item label="付款对象" prop="accountName">
				<el-input clearable v-model="editForm.accountName" type="text" class="input_200px" size="small" :disabled="editForm.isConfirm == true" />
			</el-form-item>
			<el-form-item label="支付凭证">
				<ImageListUpload
					v-model="fileList"
					class="input_200px"
					:file-limit="1"
					FileTypeId="reimbursement"
					:file-size="5"
					:disabled="editForm.isConfirm == true"
					:is-edit="editForm.isConfirm == false"
					@input="handleInput"
				/>
			</el-form-item>
		</el-form>
		<div class="drawer-footer">
			<el-button v-if="editForm.isConfirm == false" size="small" icon="el-icon-check" :loading="loading" @click="submitForm('editForm')">保存</el-button>
		</div>
	</el-drawer>
</template>

<script>
import { SaveStoreExpense, GetStoreExpenseDetail } from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import ImageListUpload from "@/components/ImageListUpload.vue";
export default {
	watch: {
		editFormVisible(visible) {
			if (!visible) return;
			this.GetOrgInfoListByConfig();
		}
	},
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				storeKeyId: "",
				filePath: "",
				content: "",
				expenseMoney: 0,
				isConfirm: false,
				accountName: ""
			},
			storeList: [],
			// rules 表单验证
			rules: {
				storeKeyId: [
					{
						required: true,
						message: "请选择门店",
						trigger: "blur"
					}
				],
				content: [
					{
						required: true,
						message: "请输入开支内容",
						trigger: "blur"
					}
				],
				expenseMoney: [
					{
						required: true,
						message: "请输入开支金额",
						trigger: "blur"
					},
					// 报销金额必须是数字
					{
						type: "number",
						message: "开支金额必须是数字",
						trigger: "blur"
					},
					// 报销金额必须大于0
					{
						validator: (rule, value, callback) => {
							if (value <= 0) {
								callback(new Error("开支金额必须大于0"));
							} else {
								callback();
							}
						},
						trigger: "blur"
					}
				],
				accountName: [
					{
						required: true,
						message: "请输入付款对象",
						trigger: "blur"
					}
				]
			},
			fileList: []
		};
	},
	created() {},
	mounted() {},
	components: {
		ImageListUpload
	},
	methods: {
		//显示编辑界面
		editShow(row) {
			this.fileList = [];
			if (row != undefined && row != "undefined") {
				this.title = "编辑";
				let parmer = {
					keyId: row.keyId
				};
				GetStoreExpenseDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.editForm = res.data;
							if (res.data.filePath != null && res.data.filePath != "") {
								this.fileList = JSON.parse(res.data.filePath);
							}
							this.editFormVisible = true;
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.editFormVisible = false;
						this.loading = false;
						this.$message.error("获取报销费用详情失败，请稍后再试！");
					});
			} else {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editFormVisible = true;
				this.fileList = [];
			}
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			if (this.editForm.filePath == "") {
				this.$message.error("请上传支付凭证！");
				return;
			}
			this.$refs[editData].validate((valid) => {
				if (valid) {
					SaveStoreExpense(this.editForm)
						.then((res) => {
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "开支费用保存成功！"
								});
								this.editFormVisible = false;
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("开支费用保存失败，请稍后再试！");
						})
						.finally(() => {
							this.loading = false;
						});
				} else {
					return false;
				}
			});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		handleInput(file) {
			if (file.length > 0) {
				this.editForm.filePath = JSON.stringify(file);
			} else {
				this.editForm.filePath = "";
			}
		}
	}
};
</script>
<style scoped>
.wip {
	width: 200px !important;
}
</style>
